const Containers = {
    BLANK_LINK: "#!",
    HOME_LINK: "/home",
    GENERIC_ERROR_MSG: 'There was a problem in connecting to the server. Please check your internet and try again.'
};

export default Containers;
